import { jsx as _jsx } from "react/jsx-runtime";
import { Breakpoint, ButtonLink, ConditionalWrapper, Link } from '@yonderland/andes-react';
const getVariantMapping = (appearance) => {
    switch (appearance) {
        case 'outlined':
            return 'secondary';
        case 'subtle':
            return 'tertiary';
        default:
            return 'primary';
    }
};
const CallToAction = ({ label, link, target, style, theme, appearance, inverse, fullWidth, hideOnMobile = false, analyticsId, }) => {
    const buttonProps = {
        variant: getVariantMapping(appearance),
        theme,
        inverse,
        fullWidth,
        href: link,
        target,
    };
    return (_jsx(ConditionalWrapper, { condition: hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsx(ConditionalWrapper, { condition: !!analyticsId, wrapper: children => _jsx("div", { "data-analytics-bannerid": analyticsId, children: children }), children: style === 'base' ? _jsx(ButtonLink, Object.assign({}, buttonProps, { children: label })) : _jsx(Link, Object.assign({}, buttonProps, { children: label })) }) }));
};
export default CallToAction;
